import {PhaExpiration} from './pha-sheet.model';

export interface PhaSectionSettings {
    targetDte: number;
    otmStep: number;
}

export const PHA_OTM_STEPS = [1, 5, 10, 15, 20, 25];

export function sectionSettings(value?: Partial<PhaSectionSettings>): PhaSectionSettings {
    return {
        targetDte: value && Number.isInteger(value.targetDte) && value.targetDte >= 0 ? value.targetDte : 14,
        otmStep: value && PHA_OTM_STEPS.indexOf(value.otmStep) >= 0 ? value.otmStep : 1
    };
}

/** Closest listed expiration; later wins a tie, then option root gives a stable same-date order. */
export function nearestExpiration(expirations: PhaExpiration[], targetDte: number,
                                  dteOf: (date: string) => number): PhaExpiration | null {
    if (!Number.isInteger(targetDte) || targetDte < 0) { return null; }
    return (expirations || []).filter(e => e.strikes && e.strikes.length)
        .map(expiration => ({expiration, dte: dteOf(expiration.date)}))
        .filter(e => Number.isFinite(e.dte) && e.dte >= 0)
        .sort((a, b) => Math.abs(a.dte - targetDte) - Math.abs(b.dte - targetDte)
            || b.dte - a.dte
            || String(a.expiration.descriptor && a.expiration.descriptor.expirationTicker || '')
                .localeCompare(String(b.expiration.descriptor && b.expiration.descriptor.expirationTicker || '')))
        .map(e => e.expiration)[0] || null;
}
